/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonSearchResultDto
 */
export interface PersonSearchResultDto {
    /**
     * 
     * @type {string}
     * @memberof PersonSearchResultDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonSearchResultDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonSearchResultDto
     */
    registerId?: string | null;
}

/**
 * Check if a given object implements the PersonSearchResultDto interface.
 */
export function instanceOfPersonSearchResultDto(value: object): value is PersonSearchResultDto {
    return true;
}

export function PersonSearchResultDtoFromJSON(json: any): PersonSearchResultDto {
    return PersonSearchResultDtoFromJSONTyped(json, false);
}

export function PersonSearchResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonSearchResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'registerId': json['registerId'] == null ? undefined : json['registerId'],
    };
}

export function PersonSearchResultDtoToJSON(json: any): PersonSearchResultDto {
    return PersonSearchResultDtoToJSONTyped(json, false);
}

export function PersonSearchResultDtoToJSONTyped(value?: PersonSearchResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'registerId': value['registerId'],
    };
}

